module.exports = __webpack_public_path__ + "public/rightArrow.svg?0079a97d";


//////////////////
// WEBPACK FOOTER
// ./public/rightArrow.svg
// module id = 3075
// module chunks = 8